// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Burger_wrapper__3ZLpm","subWrapper":"Burger_subWrapper__3QCp7","line":"Burger_line__2rlmT","isOpen":"Burger_isOpen__3eQKa"};